import React from 'react';
import { useParams } from 'react-router-dom';

import ProjectUpdateForm from 'components/Project/ProjectUpdateForm/ProjectUpdateForm';

const ProjectUpdatePage: React.FC = () => {
  const { accountId = '', projectId = '' } = useParams();

  return <ProjectUpdateForm accountId={accountId} projectId={projectId} data-testid="project-update-page" />;
};

export default ProjectUpdatePage;
